import { render, staticRenderFns } from "./TrainingCoursesTabInvoices.vue?vue&type=template&id=50d6e4df&"
import script from "./TrainingCoursesTabInvoices.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesTabInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports